export default "/kiban/_next/static/images/close-a0fdef6d1c3a7b55fc64ca4a1dc2404a.png";